module.exports = __webpack_public_path__ + "static/media/noIropsatclist.e2a2ff2c.svg";